import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationFacade } from '@core/facades/notification.facade';
import { AuthService } from '@core/services/auth.service';
import { LoadingService } from '@core/services/loading.service';
import { Store } from '@ngxs/store';
import { ButtonDirective, SpinDirective } from '@shared/directives/button.directive';
import {
  backdropAnimation,
  modalPanelAnimation,
} from '@shared/ui/confirm-dialog/animations';
import { InputLabelComponent } from '@shared/ui/input-label/input-label.component';
import { InputComponent } from '@shared/ui/input/input.component';
import { AuthActions } from 'app/auth/store/auth.actions';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-two-factor',
  standalone: true,
  imports: [
    CommonModule,
    A11yModule,
    ButtonDirective,
    InputLabelComponent,
    InputComponent,
    ReactiveFormsModule,
    FormsModule,
    SpinDirective,
  ],
  templateUrl: './two-factor.component.html',
  styleUrl: './two-factor.component.scss',
  animations: [backdropAnimation, modalPanelAnimation],
})
export class TwoFactorComponent implements OnInit, OnDestroy{
  fb = inject(FormBuilder);
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  authService = inject(AuthService);
  store = inject(Store);
  notify = inject(NotificationFacade);
  loadingService = inject(LoadingService)

  isOpen: boolean = true;
  currentSection!: string;
  subs: Subscription[] = [];
  qrCodeUrl: string = '';
  isLoading$!: Observable<boolean>;

  twoFactorForm = this.fb.nonNullable.group({
    OTP: ['', Validators.required],
  });

    constructor() {
    this.isLoading$ = this.loadingService.getLoadingObservable('verify2FA');
  }
  ngOnInit(): void {
    this.currentSection =
      this.activatedRoute.snapshot.routeConfig?.path || '2fa';
    console.log('Current Section:', this.currentSection);
    if (this.currentSection === 'setup') {
      this.setup2FA();
    }
  }

  closeModal() {
    this.router.navigate(['/auth/login']);
  }

  setup2FA() {
    const sub = this.authService.setup2FA().subscribe({
      next: (response: any) => {
        this.qrCodeUrl = response.qrCode;
        console.log('2FA Setup Response:', response);
        // Handle the response, e.g., show QR code or secret key to the user
      },
      error: (error) => {
        console.error('Error setting up 2FA:', error);
        // Handle error, e.g., show error message to the user
      },
    });
    this.subs.push(sub);
  }

  verify2FA() {
    if (!this.twoFactorForm.value.OTP) {
      this.notify.error('Please enter the OTP code');
      return;
    }
    this.store.dispatch(new AuthActions.Verify2FA(this.twoFactorForm.value.OTP));
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
